const getVideoPlayer = () => ({
    player: null,
    isPlaying: () => false,
    getCurrentTime: () => 0,
    getVideoDuration: () => 0,
    attachEvents: () => undefined,
});
export default getVideoPlayer;
